import * as React from 'react';
import { SVGProps } from 'react';

const SvgWorkspaceSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 3 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#workspaceSettings_svg__a)' fill='#000'>
      <path d='M19.184 17.143H18.04V16h.571v-2.286h-2.285v.572h-1.143v-1.143a.571.571 0 0 1 .571-.572h3.429a.572.572 0 0 1 .571.572v3.428a.572.572 0 0 1-.571.572Z' />
      <path d='M16.326 20h-3.428a.571.571 0 0 1-.572-.571V16a.571.571 0 0 1 .572-.571h3.428a.571.571 0 0 1 .572.571v3.429a.572.572 0 0 1-.572.571Zm-2.857-1.143h2.286v-2.286h-2.286v2.286ZM11.184 14.204A2.283 2.283 0 1 1 14.04 12h1.143a3.43 3.43 0 1 0-4 3.377v-1.173Z' />
      <path d='m19.12 10.6-1.32 1.16-.81-.811 1.377-1.212-1.349-2.331-1.966.663a5.354 5.354 0 0 0-1.543-.898l-.405-2.028h-2.697L10 7.17a5.063 5.063 0 0 0-1.549.898l-1.96-.663-1.348 2.331 1.554 1.366a5.082 5.082 0 0 0 0 1.788l-1.554 1.372 1.348 2.331 1.966-.663c.46.384.982.687 1.543.898l.406 2.028h.777V20h-.777a1.143 1.143 0 0 1-1.12-.92l-.292-1.44a6.512 6.512 0 0 1-.748-.429l-1.389.469a1.164 1.164 0 0 1-.938-.094 1.127 1.127 0 0 1-.416-.42l-1.349-2.332A1.143 1.143 0 0 1 4.39 13.4l1.098-.96a5.661 5.661 0 0 1-.018-.44c0-.149.012-.291.023-.434L4.39 10.6a1.143 1.143 0 0 1-.234-1.434l1.349-2.332a1.127 1.127 0 0 1 .988-.571c.124 0 .248.019.366.057l1.383.469c.242-.16.494-.303.754-.429l.292-1.44a1.143 1.143 0 0 1 1.12-.92h2.697a1.143 1.143 0 0 1 1.12.92l.291 1.44c.259.126.509.27.749.429l1.388-.469a1.165 1.165 0 0 1 .938.094c.174.1.318.246.417.42l1.348 2.332a1.143 1.143 0 0 1-.234 1.434Z' />
    </g>
    <defs>
      <clipPath id='workspaceSettings_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgWorkspaceSettings;
